<template>
  <div id="drawpad" :style="{height: height + 'px', width: width + 'px'}">
    <div id="doka-root"></div>
  </div>
</template>

<style lang="scss">
</style>

<script>
import $ from 'jquery';
import * as Doka from '../lib/doka/doka.esm.min';

export default {
  name: 'DrawPad',
  methods: {
    ok: function (event) {
      var self = this;
      var drawpad = this.$options.element;
      console.debug(event);
      kendo.ui.progress(drawpad, true);
      window.setTimeout(complete, 5000);
      function complete() {
        kendo.ui.progress(drawpad, false);
      }
      self.send_file(event.file, complete);
    },
    send_file: function (blob, callback) {
      var filename = 'drawing.' + Date.now() + '.jpg';
      var message = new FormData();
      var req = new XMLHttpRequest()
      var socket = this.$root.$options.socket;
      message.set('file', blob, filename);
      req.open('POST', '/upload?T=' + this.$root.token);
      req.onerror = function () {
        console.error('Failed to upload signature file');
        callback();
      };
      req.onload = function () {
        socket.emit('file-upload', {name: filename});
        socket.emit('change', {id: 'drawpad', value: filename});
        socket.emit('click', {id: 'drawpadcomplete'});
        callback();
      };
      req.send(message);
    }
  },
  mounted: function () {
    console.debug('drawpad-mounted:', this);
    var drawpad = this.$options.element = $('#drawpad');
    var ems = (typeof this.width === 'string' && this.width.endsWith('em'));
    this.width = parseInt(this.width, 10) * (ems ? 14 : 1);
    ems = (typeof this.height === 'string' && this.height.endsWith('em'));
    this.height = parseInt(this.height, 10) * (ems ? 14 : 1);
    var doka = Doka.create(drawpad.children().get(0), {
      allowButtonCancel: true,
      allowButtonConfirm: true,
      allowDropFiles: true,
      outputType: 'image/jpeg',
      style: {
        height: this.height + 'px',
        width: this.width + 'px'
      }
    });
    doka.on('confirm', this.ok);
    doka.on('init', function () {
      drawpad.data('doka-loaded', true);
      $(document).trigger('CHI:drawpad-mounted');
    });
  },
  props: {
    height: {default: '600px'},
    width: {default: '800px'}
  }
};
</script>
